import { useEffect } from "react";
import keycloak from "./keycloak";
import AdminApp from "./AdminApp";
import { ClubProvider } from "./club/ClubContext";
import PrivacyPolicyPage from "./legal/PrivacyPolicyPage";

// Seiten, die ohne Login erreichbar sein müssen (z. B. rechtlich vorgeschrieben)
const PUBLIC_PATHS = ["/datenschutz"];

export default function App() {
  const isPublicPath = PUBLIC_PATHS.includes(window.location.pathname);

  useEffect(() => {
    if (isPublicPath) return;
    if (!keycloak.authenticated) {
      keycloak.login(); // 🔥 sofortiger Redirect zu Keycloak
    }
  }, [isPublicPath]);

  if (isPublicPath) {
    return <PrivacyPolicyPage />;
  }

  // Während Redirect / Initialisierung nichts rendern
  if (!keycloak.authenticated) {
    return null; // oder <LoadingScreen />
  }

  return (
    <ClubProvider>
      <AdminApp />
    </ClubProvider>
  );
}
